import { audioPlayer } from "../PhaserExtension";
import * as GameModel from "../models/GameModel";
import StaticText from "../general/objects/StaticText";
import { screenResizer } from "../ReadinessScreenResizer";

export default class BaseState extends Phaser.State
{
    preload()
    {
        this.minLoadTime = 2000;
        this.backgroundLayer = this.game.add.group();
        this.maingroundLayer = this.game.add.group();
        this.foregroundLayer = this.game.add.group();
        this.transitionLayer = this.game.add.group();
        this.debugLayer = this.game.add.group();
        this.debugLayer.fixedToCamera = true;

        this.transitionLayer.add(GameModel.data.transition);
        this.transitionLayer.add(GameModel.data.loadBar);
        this.maxWidth = GameModel.data.loadBar.width;
        this.transitionLayer.fixedToCamera = true;
        this.cropRect = new Phaser.Rectangle(0, 0, 1, GameModel.data.loadBar.height);
        GameModel.data.loadBar.crop(this.cropRect);

        if(GameModel.data.groverTransition === 2)
        {
            GameModel.data.transition.loop("transition_grover_still", false, true);
            this.minTimeElapsed = false;
        }
        else if(GameModel.data.groverTransition === 1)
        {
            GameModel.data.transition.loop("transition_groverAlt_still", false, true);
            this.minTimeElapsed = false;
        }
        else
        {
            GameModel.data.transition.loop("transition_still", false, true);
            this.minTimeElapsed = true;
        }

        this.startTime = Date.now();

        this.game.load.onFileComplete.add(this._onFileComplete, this);
    }

    _onFileComplete(progress, cacheKey, success, totalLoaded, totalFiles)
    {
        let fakedProgress = 100;

        if(!this.minTimeElapsed)
        {
            fakedProgress = (Date.now() - this.startTime) / (this.minLoadTime) * 100;
        }

        this.cropRect.width = this.maxWidth * (Math.min(fakedProgress, progress) / 100);
        GameModel.data.loadBar.updateCrop();
    }

    _onLoadingMinTimeElapsed()
    {
        this.minTimeElapsed = true;
        this._startTransitionIn();
    }

    create()
    {
        // Call this after setting up the scene
        this.loaded = true;
        this.game.load.onFileComplete.remove(this._onFileComplete, this);

        this.sharedConfig = this.game.cache.getJSON("mainConfig");
        this.addVersionText();

        screenResizer.resizeByDimensions();
        this._startTransitionIn();
    }

    update()
    {
        if(this.loaded && !this.minTimeElapsed)
        {
            var progress = (Date.now() - this.startTime) / (this.minLoadTime) * 100;

            this.cropRect.width = Math.max(this.maxWidth * (progress / 100), 1);
            GameModel.data.loadBar.updateCrop();

            if(Date.now() - this.startTime > this.minLoadTime)
            {
                this._onLoadingMinTimeElapsed();
            }
        }
    }

    _startTransitionIn()
    {
        if(this.loaded && this.minTimeElapsed)
        {
            if(GameModel.data.groverTransition === 2)
            {
                GameModel.data.transition.playOnce("transition_grover_end", false, true);
            }
            else if(GameModel.data.groverTransition === 1)
            {
                GameModel.data.transition.playOnce("transition_groverAlt_end", false, true);
            }
            else
            {
                GameModel.data.transition.playOnce("transition_end", false, true);
            }

            GameModel.data.transition.onComplete.addOnce(this.onTransitionInComplete, this);
            GameModel.data.loadBar.cropRect = null;
            this.transitionLayer.removeChild(GameModel.data.loadBar);
            audioPlayer.play(this.game, this.sharedConfig.sounds.wipe);
        }
    }

    onTransitionInComplete()
    {
        GameModel.data.transition.visible = false;
        this.game.input.enabled = true;
    }

    transistionOut()
    {
        GameModel.data.transition.visible = true;

        if(GameModel.data.groverTransition === 2)
        {
            GameModel.data.transition.playOnce("transition_grover_start", false, true);
        }
        else if(GameModel.data.groverTransition === 1)
        {
            GameModel.data.transition.playOnce("transition_groverAlt_start", false, true);
        }
        else
        {
            GameModel.data.transition.playOnce("transition_start", false, true);
        }

        GameModel.data.transition.onComplete.addOnce(this.onTransitionOutComplete, this);
        audioPlayer.play(this.game, this.sharedConfig.sounds.wipe);
        this.game.input.enabled = false;
    }

    onTransitionOutComplete()
    {
        // Override to end scene
    }

    shutdown()
    {
        this.transitionLayer.destroy(false);
        this.backgroundLayer.destroy(true);
        this.maingroundLayer.destroy(true);
        this.foregroundLayer.destroy(true);
        this.debugLayer.destroy(true);
        delete this.transitionLayer;
        delete this.backgroundLayer;
        delete this.maingroundLayer;
        delete this.foregroundLayer;
        delete this.debugLayer;
        delete this.sharedConfig;
        delete this.cropRect;

        if(this.versionText) delete this.versionText;

        if(this.config) delete this.config;

        if(this.loadingTimer)
        {
            this.loadingTimer.destroy();
            delete this.loadingTimer;
        }

        this.game = null;
    }

    addVersionText()
    {
        if (this.sharedConfig.variables.isDebug)
        {
            this.versionText = new StaticText(this.game, this.sharedConfig.assets.versionText);
            this.debugLayer.add(this.versionText);
        }
    }
}
